import { IDataGridColumn } from '../../../../common/interfaces/IDataGridColumn';

export const DisclosureDetailColumns: IDataGridColumn[] = [
  {
    name: 'factName',
    labelCopy: 'name',
    sortable: false,
    interactive: false,
    flexBasis: '15%',
  },
  {
    name: 'value',
    labelCopy: 'value',
    sortable: false,
    interactive: false,
    flexBasis: '15%',
  },
  {
    name: 'attributes',
    labelCopy: 'attributes',
    sortable: false,
    interactive: false,
    flexBasis: '70%',
  },
];
